<template>
  <tr>
    <td>
      <span>{{ subscriber.name }}</span>
    </td>
    <td>
      <span>{{ subscriber.email }}</span>
    </td>
    <td>
      <span>{{ subscriber.status }}</span>
    </td>
    <td>
      <span>{{ moment(subscriber.inserted_at).format('DD.MM.YYYY.') }}</span>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['subscriber'],
  name: 'Subscriber',
}
</script>
